/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.IQ11TokenResponse, (_params: vp.IQ11CompleteRequest) => void, () => void];

function usePostIQ11Complete({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [params, setParams] = useState<vp.IQ11CompleteRequest>();
  const [response, setResponse] = useState<vp.IQ11TokenResponse>({
    Success: false,
    ErrorMessage: '',
    Token: '',
  });
  const [, setDataFetchingInfo] = useDataFetchIndicator();
 
  useEffect(() => {
    const sendRequest = async (requestParams: vp.IQ11CompleteRequest) => {
      setDataFetchingInfo(true, `${t('addingBank')}`, 'fullScreen');

      const res = await api.postIQ11Complete(requestParams, source);

      setResponse(res);
      setDataFetchingInfo(false);
      setSendRequest(false);
      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.IQ11CompleteRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Token: '',
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostIQ11Complete);
